import Client from '../HttpClient';

const baseUrl = '/mole-api/spinning-wheel/admin';

const getChanceList = (merchantId, params) =>
	Client.get(`${baseUrl}/chances/list/${merchantId}`, params);

const getChances = (customerId, merchantId) =>
	Client.get(`${baseUrl}/chances/${customerId}/${merchantId}`);

const addChances = (data) => Client.post(`${baseUrl}/chances/add`, data);

const deductChances = (data) => Client.post(`${baseUrl}/chances/deduct`, data);

const getChanceLogs = (customerId, merchantId, params) =>
	Client.get(`${baseUrl}/chances/logs/${customerId}/${merchantId}`, params);

const getActiveRewards = (merchantId) =>
	Client.get(`${baseUrl}/rewards/${merchantId}/active`);

const getRewards = (merchantId, params) =>
	Client.get(`${baseUrl}/rewards/${merchantId}`, params);

const createReward = (data) => Client.post(`${baseUrl}/rewards`, data);

const updateReward = (rewardId, data) =>
	Client.put(`${baseUrl}/rewards/${rewardId}`, data);

const deleteReward = (rewardId) => Client.del(`${baseUrl}/rewards/${rewardId}`);

const getActivity = (merchantId, activityCode) =>
	Client.get(`${baseUrl}/activity/${merchantId}/${activityCode}`);

const createActivity = (data) => Client.post(`${baseUrl}/activity`, data);

const getEventRules = (merchantId) =>
	Client.get(`${baseUrl}/event-rules/${merchantId}`);

const createEventRule = (data) => Client.post(`${baseUrl}/event-rules`, data);

const updateEventRule = (ruleId, data) =>
	Client.put(`${baseUrl}/event-rules/${ruleId}`, data);

const deleteEventRule = (ruleId) =>
	Client.del(`${baseUrl}/event-rules/${ruleId}`);

const getDeadLetters = (params) =>
	Client.get(`${baseUrl}/grant/dead-letters`, params);

const retryDeadLetter = (deadLetterId, data) =>
	Client.post(`${baseUrl}/grant/dead-letters/${deadLetterId}/retry`, data);

const markDeadLetterOfflineHandled = (deadLetterId, data) =>
	Client.post(
		`${baseUrl}/grant/dead-letters/${deadLetterId}/offline-handled`,
		data
	);

export default {
	getChanceList,
	getChances,
	addChances,
	deductChances,
	getChanceLogs,
	getActiveRewards,
	getRewards,
	createReward,
	updateReward,
	deleteReward,
	getActivity,
	createActivity,
	getEventRules,
	createEventRule,
	updateEventRule,
	deleteEventRule,
	getDeadLetters,
	retryDeadLetter,
	markDeadLetterOfflineHandled,
};
